export default class NotFoundException extends Error {
  public isNotFoundException: boolean = true;
}
